import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { classroomCourseReducer } from './classroom-course.reducer';
import { ClassroomCourseEffects } from './classroom-course.effects';
import { ClassroomCourseStoreService } from './services/classroom-course.store.service';
import { ClassroomCourseResolver } from './services/classroom-course.resolver';
import { classroomFeatureKey } from './classroom-course.state';

@NgModule({
  imports: [
    StoreModule.forFeature(classroomFeatureKey, classroomCourseReducer),
    EffectsModule.forFeature([ClassroomCourseEffects]),
  ],
  providers: [ClassroomCourseStoreService, ClassroomCourseResolver],
})
export class ClassroomStoreModule {}
